import { useState, useEffect } from 'react';
import { getSgrData, SgrData } from '../services/SgrService';

/**
 * Hook para cargar los datos de la SGR del tenant actual.
 * Incluye nombre, logo, CUIT y demás datos de la empresa.
 */
export const useSgrData = () => {
  const [sgrData, setSgrData] = useState<SgrData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSgrData = async () => {
      try {
        const response = await getSgrData();
        if (response.success && response.data) {
          setSgrData(response.data);
        } else {
          setError(response.message || 'Error al cargar datos de SGR');
        }
      } catch (err) {
        console.error('Error fetching SGR data:', err);
        setError('Error al cargar datos de SGR');
      } finally {
        setIsLoading(false);
      }
    };

    fetchSgrData();
  }, []);

  return { 
    sgrData, 
    sgrName: sgrData?.name || null,
    sgrLogo: sgrData?.logo || null,
    sgrCuit: sgrData?.cuit || null,
    isLoading, 
    error 
  };
};
